/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { applyMiddleware, compose, createStore } from 'redux';
import rootReducer from './reducers';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import { thunk } from 'redux-thunk';

const persistConfig = {
  key: 'store',
  storage,
  whitelist: ['machineListFilter', 'softwareListFilter', 'commonListFilter'],
  blacklist: ['softwares', 'machines'],
};

const pReducer = persistReducer(persistConfig, rootReducer);
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const composeEnhancers = compose;
const store = createStore(pReducer, /* preloadedState, */ composeEnhancers(applyMiddleware(thunk)));
const persistore = persistStore(store);

export { persistore, store };

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export type StoreType = ReturnType<typeof rootReducer>;
